import { Link } from "react-router-dom";
import homeLogo from "../../assets/course-details/homeLogo.svg";
import arrowIcon from "../../assets/course-details/arrow.svg";
import { useEffect } from "react";

const Path = ({ data }) => {

  useEffect(() => {
    console.log("dat in pth ", data)
  }, [])
  return (
    <div className="ml-[10px] sm:ml-[75px] py-2 flex gap-x-2 items-center md:ml-10">
      <Link to="/">
        <img
          width={20}
          height={20}
          src={homeLogo}
          alt="Home Logo"
        />
      </Link>
      <img
        src={arrowIcon}
        width={20}
        height={20}
        alt="Arrow"
      />
      <p className="text-[#737373]">Courses</p>
      <img
        src={arrowIcon}
        width={20}
        height={20}
        alt="Arrow"
      />
      <p
        className="text-primary-color truncate overflow-hidden whitespace-nowrap"
        title={data.programName}
      >
        {data.programName}
      </p>
    </div>
  );
};

export default Path;
